import { User } from "../../../redux/user/userSlice";
import axios from "../../privateApi";

type GetUserResponse = {
  user: User;
  players: {
    playerCount: number;
    lastImportedAt: number;
  };
};

export const getUser = async () => {
  const { data } = await axios.get<GetUserResponse>("users/profile");
  const { playerCount, lastImportedAt } = data.players;

  return {
    ...data.user,
    firstTimeLogin: data.user.firstTimeLogin,
    playerCount,
    lastImportedAt,
  };
};
